const adjustedPlacementFee = (engagement, recruiter) => {
  const { job } = engagement;
  let fee = job.estimatedPlacementFee * (1 - engagement.handlingFee);

  if (job.currencyId !== recruiter?.currencyId) return 0;

  fee *= job.numberOfPositions - job.filledPositionsCount;

  return fee;
};

export const sumEstimatedPlacementFees = (engagements, recruiter) => {
  const estimate = engagements.reduce(
    (total, engagement) => total + adjustedPlacementFee(engagement, recruiter),
    0
  );

  return estimate.toFixed(0);
};

export default sumEstimatedPlacementFees;
